import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Button } from './components/Button';
import { SocialProofPopup } from './components/SocialProofPopup';
// Meta Pixel Types
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const FadeIn = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.5,
  delay
}} data-id="element-0">
    {children}
  </motion.div>;
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      window.fbq('init', '790333870788238');
      window.fbq('track', 'PageView');
    }
  }, []);
  const scrollToCompra = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-brand-navy selection:bg-brand-pink selection:text-white pb-20" data-id="element-1">
      <SocialProofPopup data-id="element-2" />

      {/* TOP ANNOUNCEMENT BAR */}
      <div className="bg-brand-red text-white text-center py-2 px-4 text-sm font-medium w-full" data-id="element-3">
        🔥 Acceso inmediato + Bonus gratis
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-10" data-id="element-4">
        {/* 1. HERO SECTION */}
        <section className="text-center mb-20" data-id="element-5">
          <FadeIn data-id="element-6">
            <p className="text-brand-gray sm:text-base mb-2 font-medium text-[12px]" data-id="element-7">
              "Recurso educativo digital para docentes de inglés"
            </p>
            <h1 className="sm:text-4xl md:text-5xl font-black text-brand-pink mb-4 text-[24px]" data-id="element-8">
              MEGAPACK TEACHER'S RESOURCE
            </h1>
            <h2 className="sm:text-2xl font-bold text-brand-navy mb-8 text-[18px]" data-id="element-9">
              El sistema docente que te resuelve tus clases de inglés en minutos
            </h2>

            <div className="relative max-w-md mx-auto mb-8" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/hymjPXakKz8EvnUksxA3Mu/Diseno_sin_titulo.png" alt="Megapack Teacher's Resource" className="w-full" data-id="element-11" />
            </div>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-12">
              No pierdas tiempo buscando actividades, juegos o ideas para tus
              clases. Con este sistema vas a tener todo organizado, listo para
              usar y preparado para cada nivel.
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-10 text-left" data-id="element-13">
              <h3 className="font-bold text-lg sm:text-xl mb-6 text-center text-brand-navy" data-id="element-14">
                👉 Acceso inmediato y organizado
              </h3>
              <ul className="space-y-4" data-id="element-15">
                {['Comprás ahora', 'Recibís acceso automático', 'Entrás al material organizado por niveles', 'Podés descargar o usar directamente'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold text-base sm:text-lg" data-id="element-16">
                    <span className="mr-3 text-xl text-green-500" data-id="element-17">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </section>

        {/* 2. PREGUNTA BLOCK */}
        <section className="text-center mb-20" data-id="element-18">
          <FadeIn data-id="element-19">
            <p className="text-lg mb-4 font-[600] text-[#E91E8E]" data-id="element-20">
              Si sos docente de inglés, dejame hacerte una pregunta honesta:
            </p>
            <h2 className="sm:text-3xl font-bold mb-6 text-[20px] text-[#E53E3E]" data-id="element-21">
              ¿Sentís que preparar clases te roba demasiado tiempo?
            </h2>
            <div className="space-y-4 text-base sm:text-lg text-brand-navy max-w-2xl mx-auto" data-id="element-22">
              <p data-id="element-23">
                Es porque cada clase te obliga a volver a buscar actividades,
                pensar dinámicas y preparar todo otra vez.
              </p>
              <p data-id="element-24">
                Y entre clases, correcciones y planificación… terminás dedicando
                horas a algo que podría resolverse mucho más rápido.
              </p>
              <p className="font-bold text-xl mt-6" data-id="element-25">
                Dar clases dinámicas no debería ser tan difícil.
              </p>
            </div>
          </FadeIn>
        </section>

        {/* 3. PROBLEMA BLOCK */}
        <section className="text-center mb-20" data-id="element-26">
          <FadeIn data-id="element-27">
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-[#E91E8E]" data-id="element-28">
              El problema que muchos docentes viven todos los días:
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-8 text-left" data-id="element-29">
              <ul className="space-y-4" data-id="element-30">
                {['Pasás horas buscando actividades en Internet', 'Probás cosas que no funcionan', 'Improvisás clases a último momento', 'Terminás repitiendo siempre lo mismo'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium text-base sm:text-lg" data-id="element-31">
                    <span className="mr-3 text-brand-red font-bold text-xl" data-id="element-32">
                      •
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <p className="text-xl sm:text-2xl font-bold text-brand-navy" data-id="element-33">
              Podrías dar mejores clases… si tuvieras todo listo
            </p>
          </FadeIn>
        </section>

        {/* 4. SOLUCIÓN BLOCK */}
        <section className="text-center mb-20" data-id="element-34">
          <FadeIn data-id="element-35">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-6" data-id="element-36">
              La solución: Megapack Teacher's Resource
            </h2>

            <div className="max-w-xs mx-auto mb-8" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/of2MgfaMbKCui6PujX43tA/d056731b-fdf6-4a44-99a4-79b8c71923fe.png" alt="Megapack Teacher's Resource" className="w-full" data-id="element-38" />
            </div>

            <p className="text-base sm:text-lg text-brand-navy mb-10 max-w-2xl mx-auto" data-id="element-39">
              Un sistema completo diseñado para que tengas todo el material
              organizado y listo para usar en tus clases de inglés. Simplemente
              elegís el nivel y el contenido ya está listo para aplicar.
            </p>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto mb-10" data-id="element-40">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-lg font-bold text-brand-navy" data-id="element-41">
                <div className="flex items-center" data-id="element-42">
                  <span className="text-2xl mr-2" data-id="element-43">📂</span> Elegís el tema
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-44">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-45">⬇</span>
                <div className="flex items-center" data-id="element-46">
                  <span className="text-2xl mr-2" data-id="element-47">📖</span> Usás la actividad
                </div>
                <span className="hidden sm:inline text-brand-gray" data-id="element-48">➔</span>
                <span className="sm:hidden text-brand-gray" data-id="element-49">⬇</span>
                <div className="flex items-center text-brand-pink" data-id="element-50">
                  <span className="text-2xl mr-2" data-id="element-51">🗣</span> Aplicás la clase
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-10 font-bold text-brand-navy text-lg" data-id="element-52">
              <div className="font-[400]" data-id="element-53">
                <span className="text-green-500" data-id="element-54">✔</span>Sin perder tiempo
              </div>
              <div className="font-[400]" data-id="element-55">
                <span className="text-green-500" data-id="element-56">✔</span>Sin empezar desde cero
              </div>
              <div className="font-[400]" data-id="element-57">
                <span className="text-green-500" data-id="element-58">✔</span>Sin improvisar
              </div>
            </div>

            <div className="max-w-md mx-auto mb-10" data-id="element-59"></div>
          </FadeIn>
        </section>

        {/* 5. CONTENIDO BLOCK */}
        <section className="text-center mb-20" data-id="element-60">
          <FadeIn data-id="element-61">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-10" data-id="element-62">
              ¿Qué incluye el Megapack Teacher's Resource?
            </h2>

            <div className="space-y-8 max-w-xl mx-auto text-left" data-id="element-63">
              {/* Bloque 1 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-64">
                <h3 className="text-xl font-bold text-brand-pink mb-1 text-center" data-id="element-65">
                  🟣 BLOQUE 1 — BASES DEL INGLÉS
                </h3>
                <p className="text-brand-gray text-sm mb-5 text-center" data-id="element-66">
                  (Nivel inicial / primaria)
                </p>
                <ul className="space-y-3" data-id="element-67">
                  {['Greetings y presentación', 'Emociones', 'Familia, amigos y mascotas', 'Colores, números y formas', 'Días, clima y vocabulario básico', 'Actividades con juegos y práctica oral'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-68">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-69">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-70">
                  💡 Ideal para empezar desde cero y enganchar desde el primer
                  día
                </p>
              </div>

              {/* Bloque 2 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-71">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-72">
                  🟣 BLOQUE 2 — ESTRUCTURA Y COMUNICACIÓN
                </h3>
                <ul className="space-y-3" data-id="element-73">
                  {['Verb to be', 'Plurales', 'Artículos y preposiciones', 'Descripción de lugares', 'Rutinas diarias', 'Construcción de frases', 'Actividades y proyectos listos'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-74">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-75">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-76">
                  💡 Tus alumnos empiezan a entender y construir ideas
                </p>
              </div>

              {/* Bloque 3 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-77">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-78">
                  🟣 BLOQUE 3 — HABLAR CON CONFIANZA
                </h3>
                <ul className="space-y-3" data-id="element-79">
                  {['Presente, pasado y futuro', 'Verbos modales (can, must, should)', 'Present perfect', 'Conversaciones guiadas', 'Role plays listos'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-80">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-81">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-82">
                  💡 Más participación, más interacción real
                </p>
              </div>

              {/* Bloque 4 */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8" data-id="element-83">
                <h3 className="text-xl font-bold text-brand-pink mb-4 text-center" data-id="element-84">
                  🟣 BLOQUE 4 — INGLÉS EN LA VIDA REAL
                </h3>
                <ul className="space-y-3" data-id="element-85">
                  {['Conditional (0, 1, 2)', 'Reported speech', 'Situaciones reales e imaginarias', 'Actividades aplicadas', 'Y otras estructuras más'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-medium" data-id="element-86">
                      <span className="mr-3 text-green-500 text-lg" data-id="element-87">✔</span>
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 text-sm font-semibold text-brand-navy text-center" data-id="element-88">
                  💡 Tus alumnos usan el idioma, no solo lo estudian
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 7. CTA */}
        <section className="text-center mb-20" data-id="element-89">
          <FadeIn data-id="element-90">
            <Button data-id="element-91">👉 QUIERO RESOLVER MIS CLASES DE INGLÉS AHORA</Button>
          </FadeIn>
        </section>

        {/* 8. ANTES VS DESPUÉS */}
        <section className="mb-20" data-id="element-92">
          <FadeIn data-id="element-93">
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-94">
              {/* Antes */}
              <div className="bg-white rounded-2xl p-6 sm:p-8 border-2 border-gray-200 text-center" data-id="element-95">
                <h3 className="text-xl font-bold text-brand-gray mb-6" data-id="element-96">
                  Antes del Megapack
                </h3>
                <ul className="space-y-4 text-left" data-id="element-97">
                  {['Improvisar cada clase', 'Buscar actividades en muchos lugares', 'Repetir siempre lo mismo', 'Perder horas planificando', 'Sentir que no te alcanza el tiempo'].map((item, i) => <li key={i} className="flex items-start text-brand-gray font-medium" data-id="element-98">
                      <span className="mr-3 font-bold text-brand-red text-xl" data-id="element-99">
                        •
                      </span>
                      {item}
                    </li>)}
                </ul>
              </div>

              {/* Después */}
              <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 border-2 border-brand-lightBlue text-center" data-id="element-100">
                <h3 className="text-xl font-bold text-brand-pink mb-6" data-id="element-101">
                  Después del Megapack
                </h3>
                <ul className="space-y-4 text-left" data-id="element-102">
                  {['Clases listas para todo el año', 'Actividades organizadas', 'Más participación en el aula', 'Clases dinámicas sin esfuerzo', 'Mucho menos tiempo preparando'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold" data-id="element-103">
                      <span className="mr-3 text-green-500 text-xl" data-id="element-104">✔</span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 9. BONUS SECTION */}
        <section className="text-center mb-20" data-id="element-105">
          <FadeIn data-id="element-106">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-4" data-id="element-107">
              Además recibís estos BONUS
            </h2>
            <div className="inline-block bg-brand-pink text-white px-4 py-1 rounded-full text-sm font-bold mb-10 uppercase tracking-wide" data-id="element-108">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>

            <div className="space-y-12 max-w-sm mx-auto" data-id="element-109">
              {/* Bonus 1 - All About Me */}
              <div data-id="element-110">
                <div className="mb-3" data-id="element-111">
                  <img src="https://cdn.magicpatterns.com/uploads/27ugRgbUzLCNJRSJfQK1gw/b2c35ba1-3fa9-4a8c-a2a5-992dcf377af2.png" alt="All About Me Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-112" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-113">
                  BONUS 1 — All About Me
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-114">
                  Para primeras semanas de clases.
                </p>
              </div>

              {/* Bonus 2 - FIFA World Cup */}
              <div data-id="element-115">
                <div className="mb-3" data-id="element-116">
                  <img src="https://cdn.magicpatterns.com/uploads/crSrWZ4YSFQrnPVbF964nV/23a1ece9-44be-47fc-a767-82b55c5df021.png" alt="FIFA World Cup Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-117" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-118">
                  BONUS 2 — FIFA World Cup 2026
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-119">
                  Actividades listas para trabajar un tema que engancha a todos
                  los alumnos.
                </p>
              </div>

              {/* Bonus 3 - Songs */}
              <div data-id="element-120">
                <div className="mb-3" data-id="element-121">
                  <img src="https://cdn.magicpatterns.com/uploads/f7RGCtUG1cTVU3Jy5iZ6SK/13bb7ca3-374b-4bd7-bea3-1c0f65d7a102.png" alt="Songs Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-122" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-123">
                  BONUS 3 — Songs for English Class
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-124">
                  Canciones con actividades listas para usar en clase.
                </p>
              </div>

              {/* Bonus 4 - Flashcards */}
              <div data-id="element-125">
                <div className="mb-3" data-id="element-126">
                  <img src="https://cdn.magicpatterns.com/uploads/iEntfU5GSkNfruiEqjhTej/927ee79f-f956-46ea-9e0b-d42032277b10.png" alt="Flashcards Bonus" className="w-full aspect-square object-contain rounded-xl" data-id="element-127" />
                </div>
                <h3 className="text-base sm:text-lg font-bold text-brand-pink mb-1" data-id="element-128">
                  BONUS 4 — Flashcards Ready to Use
                </h3>
                <p className="text-brand-navy text-sm" data-id="element-129">
                  Tarjetas listas para imprimir y usar directamente.
                </p>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 10. ACCESO BLOCK */}
        <section className="text-center mb-20" data-id="element-130">
          <FadeIn data-id="element-131">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-132">
              Accedé ahora al sistema completo listo para usar todo el año
            </h2>

            <div className="bg-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto text-left" data-id="element-133">
              <p className="text-lg font-bold text-brand-navy mb-6 text-center" data-id="element-134">
                Todo lo que vas a recibir hoy:
              </p>
              <ul className="space-y-4 mb-8" data-id="element-135">
                <li className="flex items-start text-brand-navy font-bold text-lg" data-id="element-136">
                  <span className="mr-3 text-xl text-green-500" data-id="element-137">✔</span>{' '}
                  Megapack Teacher's Resource
                </li>
                <li className="flex items-start text-brand-navy font-bold text-lg" data-id="element-138">
                  <span className="mr-3 text-xl text-green-500" data-id="element-139">✔</span> BONUS
                  1: All About Me
                </li>
                <li className="flex items-start text-brand-navy font-bold text-lg" data-id="element-140">
                  <span className="mr-3 text-xl text-green-500" data-id="element-141">✔</span> BONUS
                  2: FIFA World Cup
                </li>
                <li className="flex items-start text-brand-navy font-bold text-lg" data-id="element-142">
                  <span className="mr-3 text-xl text-green-500" data-id="element-143">✔</span> BONUS
                  3: Songs
                </li>
                <li className="flex items-start text-brand-navy font-bold text-lg" data-id="element-144">
                  <span className="mr-3 text-xl text-green-500" data-id="element-145">✔</span> BONUS
                  4: Flashcards
                </li>
              </ul>

              <p className="font-bold text-brand-navy mb-4 text-center" data-id="element-146">
                Además vas a tener:
              </p>
              <div className="grid grid-cols-2 gap-4 text-brand-navy text-sm sm:text-base font-medium text-center" data-id="element-147">
                <div data-id="element-148">
                  <span className="text-green-500" data-id="element-149">✔</span> Clases listas
                </div>
                <div data-id="element-150">
                  <span className="text-green-500" data-id="element-151">✔</span> Actividades
                  organizadas
                </div>
                <div data-id="element-152">
                  <span className="text-green-500" data-id="element-153">✔</span> Material imprimible
                </div>
                <div data-id="element-154">
                  <span className="text-green-500" data-id="element-155">✔</span> Recursos por
                  niveles
                </div>
              </div>
            </div>
          </FadeIn>
        </section>

        {/* 11. RESULTADO FINAL */}
        <section className="text-center mb-20" data-id="element-156">
          <FadeIn data-id="element-157">
            <h2 className="text-2xl sm:text-3xl font-bold text-brand-navy mb-8" data-id="element-158">
              El resultado para vos como docente
            </h2>

            <div className="bg-white border-2 border-brand-lightBlue rounded-2xl p-6 sm:p-8 max-w-xl mx-auto mb-6 text-left" data-id="element-159">
              <ul className="space-y-4" data-id="element-160">
                {['Ahorrar horas de planificación', 'Tener clases listas en minutos', 'Lograr más participación', 'Sentirte más seguro al enseñar', 'Disfrutar más tus clases'].map((item, i) => <li key={i} className="flex items-start text-brand-navy font-bold text-lg" data-id="element-161">
                    <span className="mr-3 text-green-500 text-xl" data-id="element-162">✔</span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <p className="font-bold text-brand-pink text-lg" data-id="element-163">
              Todo sin perder tiempo buscando material en internet.
            </p>
          </FadeIn>
        </section>

        {/* 12. TESTIMONIOS */}
        <section className="mb-20" data-id="element-164">
          <FadeIn data-id="element-165">
            <div className="space-y-6 max-w-2xl mx-auto" data-id="element-166">
              {/* Testimonial 1 */}
              <div className="bg-brand-lightBlue p-6 rounded-2xl text-center" data-id="element-167">
                <p className="text-brand-navy italic mb-4" data-id="element-168">
                  "Me cambió completamente la forma de dar clases. Antes perdía
                  horas buscando actividades, ahora entro con todo listo."
                </p>
                <p className="font-bold text-brand-navy text-sm" data-id="element-169">
                  María Laura G., 34 años
                  <br data-id="element-170" />
                  <span className="font-normal text-brand-gray" data-id="element-171">
                    Docente de inglés en primaria, Córdoba
                  </span>
                </p>
              </div>

              {/* Testimonial 2 */}
              <div className="bg-brand-lightBlue p-6 rounded-2xl text-center" data-id="element-172">
                <p className="text-brand-navy italic mb-4" data-id="element-173">
                  "Mis alumnos participan mucho más. Las clases son dinámicas y
                  no tengo que improvisar más."
                </p>
                <p className="font-bold text-brand-navy text-sm" data-id="element-174">
                  Carolina S., 29 años
                  <br data-id="element-175" />
                  <span className="font-normal text-brand-gray" data-id="element-176">
                    Docente de inglés en secundaria, Rosario
                  </span>
                </p>
              </div>

              {/* Testimonial 3 */}
              <div className="bg-brand-lightBlue p-6 rounded-2xl text-center" data-id="element-177">
                <p className="text-brand-navy italic mb-4" data-id="element-178">
                  "Tengo todo organizado por niveles. Es increíble la cantidad
                  de material que tiene. Me ahorra horas cada semana."
                </p>
                <p className="font-bold text-brand-navy text-sm" data-id="element-179">
                  Valentina R., 41 años
                  <br data-id="element-180" />
                  <span className="font-normal text-brand-gray" data-id="element-181">
                    Profesora de inglés, Buenos Aires
                  </span>
                </p>
              </div>

              {/* Testimonial 4 */}
              <div className="bg-brand-lightBlue p-6 rounded-2xl text-center" data-id="element-182">
                <p className="text-brand-navy italic mb-4" data-id="element-183">
                  "Lo mejor es que puedo usarlo directamente. No tengo que
                  adaptar nada. Abro, elijo el tema y listo."
                </p>
                <p className="font-bold text-brand-navy text-sm" data-id="element-184">
                  Luciana M., 37 años
                  <br data-id="element-185" />
                  <span className="font-normal text-brand-gray" data-id="element-186">
                    Docente de inglés, Mendoza
                  </span>
                </p>
              </div>
            </div>
          </FadeIn>
        </section>
      </div>

      {/* 13. PRECIO SECTION - DARK BG */}
      <section id="compra" className="scroll-mt-10" data-id="element-187">
        <FadeIn data-id="element-188">
          <div className="bg-[#1a2744] py-16 px-4" data-id="element-189">
            <div className="max-w-3xl mx-auto text-center" data-id="element-190">
              <h2 className="text-2xl sm:text-3xl font-bold text-brand-pink mb-4" data-id="element-191">
                Accedé ahora al Megapack Teacher's Resource completo
              </h2>
              <p className="text-white text-base sm:text-lg mb-10 max-w-xl mx-auto font-medium" data-id="element-192">
                Tener todo el material organizado durante el año escolar puede
                ahorrarte muchísimo tiempo y trabajo.
              </p>

              <div className="max-w-xs mx-auto mb-10" data-id="element-193">
                <img src="https://cdn.magicpatterns.com/uploads/of2MgfaMbKCui6PujX43tA/d056731b-fdf6-4a44-99a4-79b8c71923fe.png" alt="Megapack Teacher's Resource" className="w-full" data-id="element-194" />
              </div>

              <div className="bg-[#0f1b33] rounded-3xl p-8 sm:p-10 max-w-xl mx-auto" data-id="element-195">
                <p className="text-gray-400 font-bold mb-2 uppercase tracking-wider text-sm" data-id="element-196">
                  PRECIO ÚNICO
                </p>
                <div className="text-4xl sm:text-5xl font-black text-white mb-8" data-id="element-197">
                  ARS $24.990
                </div>

                <Button className="w-full mb-8" href="https://checkout.aula-mater.online/cart/44808100053037:1" data-id="element-198">
                  👉 QUIERO MI MEGAPACK AHORA
                </Button>

                <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-white text-sm sm:text-base font-medium" data-id="element-199">
                  <div data-id="element-200">
                    <span className="text-green-400" data-id="element-201">✔</span> para todos los
                    niveles
                  </div>
                  <div data-id="element-202">
                    <span className="text-green-400" data-id="element-203">✔</span> acceso inmediato
                  </div>
                  <div data-id="element-204">
                    <span className="text-green-400" data-id="element-205">✔</span> descarga digital
                  </div>
                  <div data-id="element-206">
                    <span className="text-green-400" data-id="element-207">✔</span> material para
                    todo el año
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* CRÉDITO */}
      <div className="text-center py-8 px-4" data-id="element-208">
        <p className="text-brand-gray text-sm italic" data-id="element-209">
          Creado por{' '}
          <span className="font-bold text-brand-navy" data-id="element-210">Aula Mater</span>,
          proyecto educativo enfocado en facilitar el trabajo docente
        </p>
      </div>

      {/* 14. GARANTÍA */}
      <section className="text-center py-12 px-4" data-id="element-211">
        <FadeIn data-id="element-212">
          <div className="max-w-xl mx-auto" data-id="element-213">
            <img src="https://cdn.magicpatterns.com/uploads/c1WiiD5wweFWiSecTG8bGZ/pasted-image.jpg" alt="Garantía 7 días" className="w-28 h-28 mx-auto mb-4 object-contain" data-id="element-214" />
            <h2 className="text-xl sm:text-2xl font-bold text-brand-navy mb-4" data-id="element-215">
              Garantía de satisfacción de 7 días
            </h2>
            <div className="space-y-3 text-brand-navy" data-id="element-216">
              <p className="font-semibold" data-id="element-217">
                Queremos que estés 100% conforme con tu compra.
              </p>
              <p data-id="element-218">
                Probalo sin riesgo. Si no te resulta útil, podés pedir la
                devolución
              </p>
              <p className="font-bold text-brand-pink" data-id="element-219">
                Comprá con total tranquilidad: tu inversión está protegida.
              </p>
            </div>
          </div>
        </FadeIn>
      </section>

      {/* FOOTER */}
      <footer className="bg-black py-8 px-4" data-id="element-220">
        <div className="max-w-3xl mx-auto text-center space-y-4" data-id="element-221">
          <p className="text-white text-sm font-medium" data-id="element-222">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs leading-relaxed max-w-lg mx-auto" data-id="element-223">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}